import { QueryError } from '@graphql-box/helpers';

import { useQuery } from '@graphql-box/react';
import { useEffect } from 'react';
import { useToolbelt } from '#hooks/useToolbelt.ts';
import { TileCarousel } from '../TileCarousel/index.tsx';
import { formatSeasons } from './helpers/formatSeasons.ts';
import { type Props, type TvSeasonsData } from './types.ts';

const GET_TV_SEASONS = "\nquery GetTvSeasons(\n  $id: ID!\n) {\n  tv(id: $id) {\n    ...TvSeasons\n  }\n}\n\nfragment TvSeasons on Tv {\n  seasons {\n    episodeCount\n    name\n    posterPath\n    seasonNumber\n  }\n}\n";

export const SeasonsCarousel = ({ children, id, setActivePreview }: Props) => {
  const { config } = useToolbelt();

  const { execute, loading, result } = useQuery<TvSeasonsData>(GET_TV_SEASONS, {
    loading: true,
  });

  useEffect(() => {
    void execute({ variables: { id } }, { data: { initiator: 'SeasonsCarousel' } });
    // We only want to re-execute when id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (result instanceof QueryError) {
    console.error(result);
    return;
  }

  if (result?.errors?.length) {
    console.error(result.errors);
  }

  const items = formatSeasons(result?.data, id, config);

  if (!loading && items.length === 0) {
    return;
  }

  const tileCarousel = <TileCarousel items={items} setActivePreview={setActivePreview} />;
  return children ? children(tileCarousel) : tileCarousel;
};
